/* global document, global window */
import $ from 'jquery';
import 'bootstrap';
import 'eonasdan-bootstrap-datetimepicker';
import 'bootstrap-daterangepicker';
import Nette from 'nette-forms';
import 'nette.ajax.js';

import '../resources/bootstrap.less';
import '../resources/sass/main.scss';

import './analytics';
import './pages/search-global';
import './pages/table-office';
import config from './webpack/config';


Nette.initOnLoad();

const addErrorOriginal = Nette.addError;
const translations = {
	'Please enter a valid value.': 'Zadejte prosím platnou hodnotu.',
};

Nette.addError = function addError(element, message) {
	addErrorOriginal(element, translations[message] || message);
};

Nette.showFormErrors = function showFormErrors(form, errors) {
	const displayed = [];
	let focusElem;

	$(form).removeClass('has-error');
	$(form).find('.has-error').removeClass('has-error');
	$(form).find('.error-container,.help-block.error').remove();

	for (let i = 0; i < errors.length; i += 1) {
		const elem = errors[i].element;
		const message = errors[i].message;

		$(elem).closest('.form-group').addClass('has-error');
		const group = $(elem).closest('.input-group,.control-group');
		const target = group.length ? group.get(0) : elem;

		if (displayed.find(error => error.target === target && error.message === message) === undefined) {
			$(target).after($('<p></p>').addClass('help-block error').text(message));
			displayed.push({ target, message });
		}

		if (!focusElem && elem.focus) {
			focusElem = elem;
		}
	}

	if (focusElem) {
		focusElem.focus();
	}
};

Nette.validators.NetvorSDentFormsValidator_validateBirthNumber = (elem) => {
	const value = Nette.getValue(elem).replace(/\s+/g, '');
	const match = value.match(/^(\d\d)(\d\d)(\d\d)\/?(\d\d\d)(\d?)$/);
	if (!match) {
		return false;
	}

	let year;
	let month;
	const [, yearRaw, monthRaw, day, ext, checkDigit] = match;

	if (checkDigit === '') {
		year = Number(yearRaw) + (yearRaw < 54 ? 1900 : 1800);
	} else {
		// check last digit

		const mod = Number(`${yearRaw}${monthRaw}${day}${ext}`) % 11;

		if ((mod === 10 ? 0 : mod) !== Number(checkDigit)) {
			return false;
		}

		year = Number(yearRaw) + (yearRaw < 54 ? 2000 : 1900);
	}

	// month can have 20, 50 or 70 added

	if (monthRaw > 70 && year > 2003) {
		month = monthRaw - 70;
	} else if (monthRaw > 50) {
		month = monthRaw - 50;
	} else if (monthRaw > 20 && year > 2003) {
		month = monthRaw - 20;
	} else {
		month = Number(monthRaw);
	}

	const date = new Date(year, month - 1, day);

	return date &&
		date.getFullYear() === Number(year) &&
		(date.getMonth() + 1) === Number(month) &&
		date.getDate() === Number(day);
};

Nette.validators.NetvorSDentFormsValidator_validateInsuranceNumber =
	Nette.validators.NetvorSDentFormsValidator_validateBirthNumber;

$.nette.ext('bs-modal', {
	init: function bsModalInit() {
		this.ext('snippets', true).after(($el) => {
			if ($el.is('.modal')) {
				const display = $el.find('.modal-content').length;
				$el.modal(display ? 'show' : 'hide');
			}
		});

		$('.modal[id^="snippet-"]').each(function bsModalInitShow() {
			if ($(this).find('.modal-content').length) {
				$(this).modal('show');
			}
		});
	},
});

function initDateTimePicker() {
	const el = $(this);
	const minDate = el.attr('min') || undefined;
	const maxDate = el.attr('max') || undefined;

	el.datetimepicker({
		format: 'D. M. YYYY',
		locale: 'cs',
		minDate,
		maxDate,
		useCurrent: false, // Important! See issue #1075
		allowInputToggle: true,
	});
}

function initTooltip() {
	$(this).tooltip();
}

$.nette.ext('initDateTimePicker', {
	init: function initDateTimePickerInit() {
		const snippets = this.ext('snippets');
		if (!snippets) return;

		snippets.after(($el) => {
			$el.find('.datetimepicker').each(initDateTimePicker);
		});
	},
});

$.nette.ext('initTooltip', {
	init: function initTooltipInit() {
		const snippets = this.ext('snippets');
		if (!snippets) return;

		snippets.after(($el) => {
			$el.find('[data-toggle="tooltip"]').each(initTooltip);
		});
	},
});

$(() => {
	$.nette.init();

	$('.datetimepicker').each(initDateTimePicker);
	$('[data-toggle="tooltip"]').each(initTooltip);
	$('[data-toggle="popover"]').popover();

	const dateFrom = $('#dp-1');
	const dateTo = $('#dp-2');
	if (dateFrom.data('DateTimePicker') && dateTo.data('DateTimePicker')) {
		dateFrom.data('DateTimePicker').maxDate(dateTo.data('DateTimePicker').date());
		dateTo.data('DateTimePicker').minDate(dateFrom.data('DateTimePicker').date());
		dateFrom.on('dp.change', (e) => {
			dateTo.data('DateTimePicker').minDate(e.date);
		});
		dateTo.on('dp.change', (e) => {
			dateFrom.data('DateTimePicker').maxDate(e.date);
		});
	}

	$(document).on('click', 'a[data-blank]', function openLink(e) {
		if (window.open(this.href)) {
			e.preventDefault();
		}
	});

	$('.logo-drop-open, .logo-drop-open a').on('click', (e) => {
		e.preventDefault();
		e.stopPropagation();
		$('.logo-drop').toggleClass('in');
		$('.logo-drop-open .icon-dropdown').toggleClass('rotateX');
	});

	const userDropdown = $('.user-navigation .user-nav-dropdown');
	const userIcon = $('.user-navigation .user-icon');
	const refreshLink = userIcon.data('refresh');
	userIcon.click(() => {
		if (userDropdown.hasClass('hide')) {
			$.nette.ajax({
				url: refreshLink,
			}).done(() => {
				userDropdown.toggleClass('hide');
				userDropdown.find('tr.row-active').click((e) => {
					if (!$(e.target).is('a')) {
						e.preventDefault();
						e.stopPropagation();
						const row = $(e.target).parents('tr');

						// Mark message as read
						if (row.hasClass('unread')) {
							$.nette.ajax({
								url: row.find('.content-full').data('read'),
							});
							row.removeClass('unread');
						}
						row.find('.content-abbr').toggleClass('hide');
						row.find('.content-full').toggleClass('hide');
					}
				});
			});
		}
	});


	$(document).on('click', (e) => {
		if ($('.logo-drop.in')) {
			$('.logo-drop').removeClass('in');
			$('.logo-drop-open .icon-dropdown').removeClass('rotateX');
		}
		if (!userDropdown.hasClass('hide')) {
			if (!userDropdown.has(e.target).length) {
				userDropdown.toggleClass('hide');
			}
		}
	});
});

/* --- Sidebar --- */

// rotate arrow in left sidebar - select of clinic
$('#btn-dropdown-clinics').on('click', function toggleClinicSelect() {
	const arrowEl = $(this).find('#menu-down-clinic-select');
	if (arrowEl.hasClass('rotateX')) {
		arrowEl.removeClass('rotateX');
	} else {
		arrowEl.addClass('rotateX');
	}
});

$('.dropdown-clinics a').on('click', () => {
	const arrowEl = $('#btn-dropdown-clinics .glyphicon-menu-down');
	$(arrowEl).toggleClass('rotate2');
});

// Hide/Show larger/shorter menu
$('#menuToggle').on('click', () => {
	const terms = $('#support-terms-span');
	$('#sidebar').toggleClass('sidebar-short');
	$('#content').toggleClass('content-long');
	$('#arrow-toggle-wrapper').find('.glyphicon').toggleClass('rotateY');
	$('#menu-down-clinic-select').removeClass('rotateX');
	const hidden = $('#sidebar').hasClass('sidebar-short');
	if (hidden) {
		terms.fadeOut('fast');
	} else {
		terms.fadeIn('slow');
	}
	const date = new Date();
	date.setFullYear(date.getFullYear() + 1);
	document.cookie = `sidebar-hidden-2=${hidden ? 1 : 0};expires=${date.toGMTString()};path=${config.basePath || '/'}`;
});

if (document.cookie.indexOf('sidebar-hidden-2=1') !== -1) {
	$('#sidebar').addClass('sidebar-short');
	$('#content').addClass('content-long');
	$('#arrow-toggle-wrapper').addClass('rotate');
	$('#menu-down-clinic-select').removeClass('rotate');
	$('#support-terms-span').hide('fast');
}

$('.do-collapse').on('click', (e) => {
	const idToCollapse = $(e.target).parent().data('collapse');
	if ($(`#${idToCollapse}`).length) {
		$(`#${idToCollapse}`).collapse('toggle');
		$(e.target).parent().toggleClass('open');
		$(e.target).parent().find('i.glyphicon')
			.toggleClass('glyphicon-triangle-bottom, glyphicon-triangle-top');
	}
});

// Communication with patients - Turn on the checkbox for sending emails
$(document).on('change', '.communication-wrapper #fancy-checkbox-primary', (e) => {
	const checboxState = e.target.checked ? 'Zapnuto' : 'Zapnout';
	$('.special-checkbox label#text').html(checboxState);
});

/* --- Sidebar --- */

/* --- For sexy file uploader purpose START --- */
$('.upload-button').on('click', (e) => {
	e.preventDefault();
	$(e.target).parent().find('.file-upload').click();
});

$('.file-upload').on('change', (e) => {
	// we need actual changed file, save the selector
	const fileUpload = $(e.target);
	const uploadButton = fileUpload.parent().find('.upload-button');
	if (fileUpload.val() !== '') {
		// put name of the file into the button + short to 13 characters with "..."
		const wholeText = fileUpload.val();
		const newText = wholeText.slice(12);
		const finalText = newText.length > 13
			? `${newText.substring(0, 12)} ...`
			: newText;
		uploadButton.text(finalText);
	} else {
		uploadButton.text('Nahrát soubor');
	}
});
/* --- For sexy file uploader purpose END --- */

/* --- for panel scrolling --- START */
$('#btn-toggle-1').on('click', () => {
	const arrowEl = $('#menu-down-1 i');
	if (!arrowEl.hasClass('rotate')) {
		arrowEl.toggleClass('rotate');
	} else {
		arrowEl.toggleClass('rotate2');
	}
});

$('#btn-toggle-2').on('click', () => {
	const arrowEl = $('#menu-down-2 i');
	if (!arrowEl.hasClass('rotate')) {
		arrowEl.toggleClass('rotate');
	} else {
		arrowEl.toggleClass('rotate2');
	}
});
/* --- for panel scrolling --- END */

// alert when sth is changed and want to close modal // calendar, internal messages
$(document).ready(() => {
	// Init date range picker
	$('[data-daterange]').each(function dateRangePickerInit() {
		const format = 'D.M.YYYY';
		const options = {
			opens: ($(this).attr('data-daterange-opens') || 'left'),
			autoUpdateInput: false,
			autoApply: true,
			locale: {
				format,
			},
		};
		const fromInput = $(`[name=${$(this).attr('data-daterange-from') || 'dateFrom'}]`);
		const toInput = $(`[name=${$(this).attr('data-daterange-to') || 'dateTo'}]`);
		// Load default values
		if (fromInput.val() !== '') {
			const startDate = fromInput.val().split('-');
			options.startDate = new Date(startDate[0], startDate[1] - 1, startDate[2]);
		}
		if (toInput.val() !== '') {
			const endDate = toInput.val().split('-');
			options.endDate = new Date(endDate[0], endDate[1] - 1, endDate[2]);
		}
		$(this).daterangepicker(options, (start, end) => {
			$(this).val(`${start.format(format)} - ${end.format(format)}`);
			fromInput.val(start.format('YYYY-MM-DD'));
			toInput.val(end.format('YYYY-MM-DD'));
		});
		if (options.startDate || options.endDate) {
			const { startDate, endDate } = $(this).data('daterangepicker');
			$(this).val(`${options.startDate ? startDate.format(format) : ''} - ${options.endDate ? endDate.format(format) : ''}`);
		}
	});


	function hideConfirmModal(el) {
		if ($(el).attr('data-changed')) {
			// eslint-disable-next-line no-alert
			if (window.confirm('Provedené změny nebudou uloženy. Chcete odejít?')) {
				$(el).modal('hide');
				$('.modal').removeAttr('data-changed');
			}
		} else {
			$(el).modal('hide');
			$('.modal').removeAttr('data-changed');
		}
	}

	$('.modal').on('click', function modalClicked(e) {
		if (e.target === this || $(e.target).is('.close-btn, .close')) {
			hideConfirmModal('.modal.in');
		}
	});
});

$('.modal').on('hidden.bs.modal', function modalHidden() {
	$('html').removeClass('noscroll');
	const url = $(this).find('.modal-dialog[data-close-url]').data('closeUrl');
	if (url) {
		$.nette.ajax({
			url,
			off: ['abort'],
		});
	}
});

$(document).on('change', 'select.js-collecting-select', function getItems() {
	const self = $(this);
	const id = self.find(':selected').val();
	const url = self.data('url');

	if (id) {
		$.nette.ajax({
			type: 'post',
			url,
			data: { id },
		});
	}
});

$(document).on('change', '.js-tgl-ajax', (e) => {
	const checkBox = $(e.target);
	const param = checkBox.is(':checked') ? 1 : 0;
	$.nette.ajax({
		type: 'post',
		url: checkBox.data('url'),
		data: {
			param,
		},
	});
});



// WEBPACK FOOTER //
// ./js/commons.js